import { render, staticRenderFns } from "./userInformation.vue?vue&type=template&id=24052eac&scoped=true&"
import script from "./userInformation.vue?vue&type=script&lang=js&"
export * from "./userInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24052eac",
  null
  
)

export default component.exports